import StatusManage from "./set-status";

export default StatusManage